import arequest from "./request";
import config from "./config"


let ImgUrlPath = config.ImgUrlPath
    // import store from '@/store'
// 登陆
let login = (data) => {
    return arequest.create({
        url: "account/login",
        method: "post",
        data
    })
}

// 获取用户信息
let getUser = () => {
    return arequest.create({
        url: "account/info",
        method: "post",
        data: {}
    })
}

// 获取用户信息 
let userChangepwd = (data) => {
    return arequest.create({
        url: "account/changepwd",
        method: "post",
        data
    })
}





// 保存客户
let saveUser = (data) => {
    return arequest.create({
        url: "/user/save",
        method: "post",
        data
    });
}
// 客户列表
let getUserList = (data) => {
    return arequest.create({
        url: "/user/list",
        method: "post",
        data
    });
}
// 添加回访记录
let saveRecord = (data) => {
    return arequest.create({
        url: "/access/save",
        method: "post",
        data
    });
}
// 添加回访记录
let getRecord = (data) => {
    return arequest.create({
        url: "/access/list",
        method: "post",
        data
    });
}

let returnvisitSave = (data) => {
    return arequest.create({
        url: "returnvisit/save",
        method: "post",
        data
    })
}
let returnvisitList = (data) => {
    return arequest.create({
        url: "returnvisit/list",
        method: "post",
        data
    })
}

// 注册  1
let customerSave = (data) => {
    return arequest.create({
        url: "customer/save",
        method: "post",
        data
    })
}
let resumeSave = (data) => {
    return arequest.create({
        url: "/recruitment/resume/save",
        method: "post",
        data
    })
}

let customerList = (data) => {
    return arequest.create({
        url: "customer/list",
        method: "post",
        data
    })
}
let customerPublicList = (data) => {
    return arequest.create({
        url: "customer/publiclist",
        method: "post",
        data
    })
}
let customerPublicSave = (data) => {
    return arequest.create({
        url: "customer/publicsave",
        method: "post",
        data
    })
}


let customerDetial = (data) => {
    return arequest.create({
        url: "customer/detial",
        method: "post",
        data
    })
}
// let customerByTel = (tel) => {
//     return arequest.create({
//         url: "customer/bytel",
//         method: "post",
//         data:tel
//     })
// }
let getProjectList= (req) => {
    return arequest.create({
        url: 'sales/listproject ',
        method: "post",
        data: req
    })
}
let customerCheck= (data) => {
    return arequest.create({
        url: 'customer/check',
        method: "post",
        data: data
    })
}
let customerByTel= (data) => {
    return arequest.create({
        url: 'customer/bytel',
        method: "post",
        data: data
    })
}
let customerVisit= (data) => {
    return arequest.create({
        url: 'customer/visit',
        method: "post",
        data: data
    })
}
let dbsave= (data) => {
    return arequest.create({
        url: "db/save",
        method: "post",
        data: data
    })
}
let dbreq = (req) => {
    return arequest.create({
        url: "db/req",
        method: "post",
        data: req
    })
}

let jobclass = () => {
    return arequest.create({
        url: "recruitment/job/class",
        method: "post",
        data: {}
    })
}
let joblist = (req) => {
    return arequest.create({
        url: "recruitment/job/list",
        method: "post",
        data: req
    })
}
let jobDetial = (id) => {
    return arequest.create({
        url: "/recruitment/job/detail",
        method: "post",
        data: {id:id}
    })
}



let ImgUrl = (id) => {
    console
    if (id == undefined) { return '' }
    return  process.env.VUE_APP_BASE_API + '/avatar/img?id=' + id
}
let ImgID = (url) => {
    if (url == undefined) { return '' }
    return url.replace(ImgUrlPath, "")
}

let imgpath = (imgid) => {
    console.log("config.ImgUrlPath",config.ImgUrlPath)
    return config.ImgUrlPath + imgid
}
let UploadImg = (data) => {
    console.log("UploadImg",data)
    return arequest.create({
        // headers:{
        //     'Content-Type':'multipart/form-data;'
        // },
       // url: "/file/uploadimg",
       url:"avatar/content" ,  
        method: "post",
        data: data
    })
}


export default {
    login,
    saveUser,
    getUserList,
    saveRecord,
    getUser,
    getRecord,
    userChangepwd,
    ImgUrlPath,
    imgpath,
    ImgUrl,
    ImgID,
    dbreq,
    dbsave,
    customerDetial,
    customerSave,
    customerList,
    customerPublicList,
    customerPublicSave,
    customerByTel,
    customerVisit,
    returnvisitSave,
    returnvisitList,
    jobclass,
    joblist,
    jobDetial,
    UploadImg,
    resumeSave,
    getProjectList,
    customerCheck,

};